import RoutesFile from "./RoutesFile";
import { createWeb3Modal, defaultConfig } from "@web3modal/ethers/react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Roadmap from "./components/Roadmap";
import "./App.css";

// 1. Get projectId
const projectId = "45a0e6f0ec40c32ea865faa6d7000f5e";

// 2. Define chains for BSC and Polygon
const bscMainnet = {
  chainId: 56,
  name: "Binance Smart Chain",
  currency: "BNB",
  explorerUrl: "https://bscscan.com/",
  rpcUrl: "https://bsc-dataseed.binance.org/",
};

const polygon = {
  chainId: 137,
  name: "Polygon",
  currency: "MATIC",
  explorerUrl: "https://polygonscan.com/",
  rpcUrl: "https://polygon-mainnet.infura.io/v3/82dd7e624fa24a889bc681e252bf16c0", // Replace with your Infura key if needed
};

// 3. Create metadata object
const metadata = {
  name: "My Website",
  description: "My Website description",
  url: "https://mywebsite.com", // origin must match your domain & subdomain
  icons: ["https://avatars.mywebsite.com/"],
};

// 4. Create ethers config
const ethersConfig = defaultConfig({
  metadata,
});

// 5. Create a Web3Modal instance with support for BSC and Polygon
createWeb3Modal({
  ethersConfig,
  chains: [bscMainnet, polygon], // Only include BSC and Polygon
  projectId,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
});

function App() {
  return (
    <>
      <RoutesFile />
      <ToastContainer />
      {/* <Roadmap /> */}
    </>
  );
}

export default App;
